import { inject, Injectable } from '@angular/core';
import { KindeAngularService } from 'kinde-angular';
import { filter, map, Observable, of, shareReplay, switchMap } from 'rxjs';

import { UserPermission } from '../models/user-permission.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  readonly kindeService = inject(KindeAngularService);

  readonly permissions$ = this.getPermissions();

  private getPermissions(): Observable<UserPermission[]> {
    return this.kindeService.isLoading$.pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.kindeService.isAuthenticated$),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return of([] as UserPermission[]);
        }

        return this.kindeService.getClaim('permissions').pipe(map((claim) => this.mapPermissionsClaim(claim)));
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }

  private mapPermissionsClaim(claim: { value?: unknown } | null): UserPermission[] {
    if (!Array.isArray(claim?.value)) {
      return [];
    }

    return claim.value
      .map((permission) => {
        const entry = Object.values(UserPermission).find((value) => value === permission);

        return entry ?? null;
      })
      .filter((permission): permission is UserPermission => permission !== null);
  }
}
